import { z } from 'zod'

export const fetchAccountsResponseSchema = z.object({
  account_id: z.string(),
  account_name: z.string(),
  avatar_url: z.string().nullable(),
  app_status: z.number(),
  pro_status: z.boolean(),
})

export type ApplicationAccount = z.infer<typeof fetchAccountsResponseSchema>
